module.exports = __webpack_public_path__ + "static/media/spinner.751b870d.png";